class ProductCustomEngraving extends HTMLElement {
  constructor() {
    super();
    
    this.textInput = this.querySelector('input[type="text"]');
    this.inputs = this.querySelectorAll('input,select,textarea');

    this.textInput.addEventListener('input', this.onTextInputChange.bind(this));

    document.addEventListener('variant:change', (evt) => {
      this.updateProductRef(evt.detail.variant);
    });

    this.productQtyInput = this.parentNode.querySelector('product-form quantity-input input');
    if(this.productQtyInput) {
      this.productQtyInput.addEventListener('change', this.updateQty.bind(this));
    }
  }

  onTextInputChange(event) {
    if(event.target.value.length > 0) {
      this.inputs.forEach((input) => {
        if(!input.name) {
          input.name = input.dataset.name;
        }
      })
    } else {
      this.inputs.forEach((input) => {
        if(input.name) {
          input.removeAttribute('name');
        }
      })
    }
  }

  updateProductRef(variant) {
    this.querySelector('[data-main-product-title]').value = variant.name;
    this.querySelector('[data-main-product-ref]').value = variant.sku;
  }

  updateQty(event) {
    this.querySelector('[data-qty]').value = event.target.value;
  }
}

customElements.define('product-custom-engraving', ProductCustomEngraving);